import { useCases } from "./useCases";
import { solutions } from "./solutions";

export const navigation = [
  {
    label: "Solutions",
    intro: "Support for you. Possibilities for the people you serve.",
    items: [
      {
        label: "For Individuals",
        to: "/solutions/individuals",
        description: "Find support for everyday life.",
      },
      ...solutions.map((s) => ({
        label: s.title,
        to: `/solutions/${s.slug}`,
        description: s.audience,
      })),
    ],
  },
  {
    label: "Use Cases",
    intro: "Start with a moment where a little support would help.",
    items: useCases.map((c) => ({
      label: c.title,
      to: `/use-cases/${c.slug}`,
      description: c.category,
    })),
  },
  {
    label: "Platform",
    intro: "Understand the person. Adapt to the moment.",
    items: [
      {
        label: "How It Works",
        to: "/platform",
        description: "The thinking behind continuous support.",
      },
      {
        label: "Personalization",
        to: "/platform/personalization",
        description: "Your context makes the difference.",
      },
      {
        label: "Messaging & Voice",
        to: "/platform/messaging-voice",
        description: "Support through a familiar conversation.",
      },
      {
        label: "Integrations",
        to: "/platform/integrations",
        description: "What works today. What we can explore.",
      },
      {
        label: "Safety & Privacy",
        to: "/platform/safety",
        description: "Clear boundaries. Human connection.",
      },
    ],
  },
  {
    label: "Evidence",
    intro: "Thoughtful development starts with honest evaluation.",
    items: [
      {
        label: "Research Approach",
        to: "/evidence#approach",
        description: "What we want to understand.",
      },
      {
        label: "Pilots",
        to: "/evidence#pilots",
        description: "Explore a focused evaluation together.",
      },
      {
        label: "Case Studies",
        to: "/evidence#case-studies",
        description: "A place for verified findings.",
      },
    ],
  },
  { label: "Resources", to: "/resources" },
  {
    label: "About",
    intro: "Human life is continuous. Support should be too.",
    items: [
      {
        label: "About Systein",
        to: "/about",
        description: "Why we are building this.",
      },
      {
        label: "Contact",
        to: "/contact",
        description: "Start a conversation.",
      },
    ],
  },
];

export const platformSteps = [
  {
    title: "Understand",
    text: "Start with the goals, preferences, routines, and experiences a person shares.",
    icon: "heart" as const,
  },
  {
    title: "Adapt",
    text: "Shape the tone, timing, and size of the next step around their situation.",
    icon: "spark" as const,
  },
  {
    title: "Support",
    text: "Bring practical support into messages, voice, and agreed check-ins.",
    icon: "message" as const,
  },
  {
    title: "Learn",
    text: "Update the context as plans change and new experiences are shared.",
    icon: "leaf" as const,
  },
  {
    title: "Connect",
    text: "Keep room for people, professionals, and appropriately connected services.",
    icon: "people" as const,
  },
];
